import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button } from 'base-ui'

import { DirectContactPharmaTelephoneAvailableBox } from '../DirectContactPharmaTelephoneAvailableBox'

export const DirectContactPharmaTelephoneAvailable: FC = () => {
  const intl = useIntl()

  const phoneNumber = intl.formatMessage({
    id: 'contact.directContact.customerSupport.phoneNumber.pharma',
  })

  return (
    <div className="flex flex-col gap-4">
      <p className="text-m">
        <FormattedMessage id="contact.directContactSection.pharmaCustomerSupport.modal.description" />
      </p>
      <DirectContactPharmaTelephoneAvailableBox />
      <Button<'a'>
        className="w-full"
        color="primary"
        href={`tel:${phoneNumber}`}
        size="large"
        slots={{ root: 'a' }}
        variant="filled"
      >
        {phoneNumber}
      </Button>
      <p>
        <FormattedMessage id="contact.directContactSection.customerSupportDialog.freeCallDisclaimer" />
      </p>
    </div>
  )
}
